import { useGetUsersQuery } from '../../../store/api/users-api'
import { useUser } from '../../../hooks/use-user'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import { BusinessRole } from '../../../types/api/user'
import ManagerContent from '../manager-content/manager-content'
import PrinterContent from '../printer-content/printer-content'
import DesignerContent from '../designer-content/designer-content'
import { ComponentType } from 'react'

const mapPositionNames: { role: string; component: ComponentType }[] = [
    {
        role: 'Печатник',
        component: PrinterContent,
    },
    {
        role: 'Помощник печатника',
        component: PrinterContent,
    },
    {
        role: 'Менеджер',
        component: ManagerContent,
    },
    {
        role: 'Помощник менеджера',
        component: ManagerContent,
    },
    {
        role: 'Дизайнер',
        component: DesignerContent,
    },
]

const printerBusinessRoles = [BusinessRole.Printer, BusinessRole.SecondPrinter]
const managerBusinessRoles = [BusinessRole.Manager, BusinessRole.SecondManager]
const designerBusinessRoles = [BusinessRole.Designer]

function resolvePositionComponents(
    positionName: string | undefined,
    businessRoles: BusinessRole[] | undefined
): ComponentType[] {
    const byPosition = mapPositionNames
        .filter(item => item.role === positionName)
        .map(item => item.component)

    if (byPosition.length > 0) {
        return byPosition
    }

    const roles = businessRoles ?? []

    if (roles.some(role => printerBusinessRoles.includes(role))) {
        return [PrinterContent]
    }

    if (roles.some(role => managerBusinessRoles.includes(role))) {
        return [ManagerContent]
    }

    if (roles.some(role => designerBusinessRoles.includes(role))) {
        return [DesignerContent]
    }

    return []
}

export default function useProfileUser() {
    const authUser = useUser()

    const queryParams: EndpointQueryParameters | undefined = authUser?.id
        ? {
              filters: {
                  id: { $eq: authUser.id },
              },
              populate: ['user_position'],
          }
        : undefined

    const { data, isLoading } = useGetUsersQuery(queryParams, {
        skip: !authUser?.id,
    })

    const profileUser = data?.[0]
    const positionName =
        profileUser?.user_position?.name ?? authUser?.user_position?.name ?? '—'
    const businessRoles = profileUser?.businessRoles ?? authUser?.businessRoles

    const positionComponents = resolvePositionComponents(
        profileUser?.user_position?.name ?? authUser?.user_position?.name,
        businessRoles
    )

    return {
        userId: profileUser?.id ?? authUser?.id,
        username: profileUser?.username ?? authUser?.username ?? '—',
        phoneNumber: profileUser?.phoneNumber ?? authUser?.phoneNumber,
        positionName,
        positionComponents,
        isLoading,
    }
}
